export default __webpack_public_path__ + "static/media/filterArrow.cdd7a589.svg";